/** Combobox values that open New case instead of selecting a case. */
export const NEW_CASE_SENTINEL = '__new_case__';
export const CREATE_CASE_PREFIX = '__create_case__:';

export type CasePickerExtraOption = { value: string; label: string };

/**
 * Rows added to the header case picker.
 *
 * An empty query gets a leading "+ Create Case" row (the menu is unfiltered, so it
 * stays at the top). A query that matches no case gets "Create case '<query>'",
 * whose label contains the query so the combobox filter keeps it.
 * Combobox has no footer slot; these rows are the entry points until Foundations
 * adds one. TR-4241.
 */
export function casePickerExtraOptions(
  query: string,
  existingNames: readonly string[],
): CasePickerExtraOption[] {
  const trimmed = query.trim();
  if (!trimmed) {
    return [{ value: NEW_CASE_SENTINEL, label: '+ Create Case' }];
  }
  const taken = existingNames.some((name) => name.trim().toLowerCase() === trimmed.toLowerCase());
  if (taken) return [];
  return [{ value: `${CREATE_CASE_PREFIX}${trimmed}`, label: `Create case "${trimmed}"` }];
}

export function caseNameFromPickerValue(value: string): { kind: 'new' } | { kind: 'named'; name: string } | null {
  if (value === NEW_CASE_SENTINEL) return { kind: 'new' };
  if (value.startsWith(CREATE_CASE_PREFIX)) {
    return { kind: 'named', name: value.slice(CREATE_CASE_PREFIX.length) };
  }
  return null;
}
